import React from 'react'
import PropTypes from 'prop-types'
import EditableButton from '@v4/components/common/EditableButton'
import { useSignUpButton } from './SignUpButton.hooks'

const SignUpButton = props => {
	const [
		{ children, href, target, className, component, editable, rounded, rest },
		{ handleClick, handleChange },
	] = useSignUpButton(props)

	return (
		<EditableButton
			{...rest}
			className={className}
			component={component}
			href={href}
			target={target}
			onClick={handleClick}
			editable={editable}
			onChange={handleChange}
			rounded={rounded}
		>
			{children}
		</EditableButton>
	)
}

SignUpButton.propTypes = {
	action: PropTypes.string,
	children: PropTypes.string,
	className: PropTypes.string,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	editable: PropTypes.bool,
	rounded: PropTypes.bool,
	variant: PropTypes.oneOf(['filled', 'outlined']),
	color: PropTypes.oneOf(['white', 'primary', 'secondary', 'text']),
	primaryColor: PropTypes.string,
}

export default SignUpButton
